




































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import NeedLoginModal from "@/components/NeedLoginModal.vue";
import { Ticket } from "@/models/ticket";
import SystemConst from "@/config/const";
import firebase from "firebase/app";
import "firebase/firestore";
import TicketFavoriteService from "@/services/TicketFavoriteService";
import { SalonHistory } from "@/models/salon_history";
const db = firebase.firestore();
import moment from "moment";
import GetCouponModal from "@/components/GetCouponModal.vue";
import CouponService from "@/services/CouponService";

@Component({
  name: "TicketComponent",
  components: {
    NeedLoginModal,
    GetCouponModal
  },
})
export default class TicketComponent extends Vue {
  @Prop({ default: {} }) pTicket!: any;
  @Prop({ default: false }) secretSale!: boolean;
  @Prop() parent!: string;
  @Prop({ default: "" }) parentCouponId!: string;

  SystemConst = SystemConst;
  faved = false;
  isDisabled = false;
  couponCount = 0;
  couponDiscount = 0;
  purchasePrice = 0;
  discountPrice = 0;
  couponId = "";
  tempCouponId = "";
  hovered = false;
  dataWhite = "/gift_white.png";
  dataBlue = "/gift_blue.png";
  // クーポン開始日時
  couponUsageStartDate = "";
  // クーポン終了日時
  couponUsageEndDate = "";
  // クーポン利用可能下限金額(watchでチラつき防止として初期値は1000000とした)
  couponAvailableMinnimumAmount = "1000000";

  get availableDate(): any {
    return moment(this.pTicket.available_on).format("YYYY年 MM月DD日");
  }

  get discontinueDate(): any {
    return moment(this.pTicket.discontinue_on).format("YYYY年 MM月DD日");
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  get ticketType() {
    let val: any;
    if (this.pTicket.type === SystemConst.TICKET_SERVICE_TYPE_MULTIPLE) {
      if (this.pTicket.available_count > 1) {
        val = SystemConst.TICKET_SERVICE_TYPE_MULTIPLE;
      } else {
        val = SystemConst.TICKET_SERVICE_TYPE_ONEC;
      }
    } else {
      val = this.pTicket.type;
    }
    return val;
  }

  get expirationDateText() {
    let val: string;
    if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_SUBSCRIPTION) {
      val = "毎月自動更新";
    } else {
      val = this.pTicket.expiration_date
        ? `${this.pTicket.expiration_date}日間`
        : "";
    }
    return val;
  }

  get availableCountText() {
    let val: string;
    if (
      this.pTicket.available_count ===
        SystemConst.MAX_AVAILABLE_COUNT_OF_SALON &&
      this.ticketType === SystemConst.TICKET_SERVICE_TYPE_SUBSCRIPTION
    ) {
      val = "制限なし";
    } else {
      val = `${this.pTicket.available_count}回`;
    }
    return val;
  }

  get displayDiscontinueOn() {
    if (this.pTicket.discontinue_on) {
      return moment(this.pTicket.discontinue_on).format(
        "YYYY年 MM月DD日 hh時mm分"
      );
    }
    return "制限なし";
  }

  get displayQuantity() {
    if (this.pTicket.quantity) {
      return `${this.pTicket.quantity - this.pTicket.purchased_count}個`;
    }
    return "制限なし";
  }

  get ticketTypeText() {
    let val = "";
    if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_SUBSCRIPTION) {
      val = "定額(サブスク)サービス";
    } else if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_ONEC) {
      val = "単品サービス";
    } else if (this.ticketType === SystemConst.TICKET_SERVICE_TYPE_MULTIPLE) {
      val = "回数券サービス";
    }
    return val;
  }

  // モーダルクーポン利用対象の表示内容
  // TODO
  get displayUsageTarget() {
    return "通常販売、シークレットサービス";
    // if (this.secretSale) {
    //   return "シークレットサービス";
    // }
    // return "通常販売";
  }

  // モーダルクーポン利用期間の表示内容
  get displayUsagePeriod() {
    if (this.couponUsageStartDate && this.couponUsageEndDate) {
      const format = "YYYY年MM月DD日 HH:mm";
      const start = moment(new Date(this.couponUsageStartDate)).format(format);
      const end = moment(new Date(this.couponUsageEndDate)).format(format);
      return start + "～" + end;
    }
    return "制限なし";
  }

  // モーダル利用条件の表示内容
  get displayTermsOfUse() {
    if (this.couponAvailableMinnimumAmount !== "1000000") {
      return (
        this.couponAvailableMinnimumAmount.replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1,"
        ) + "円以上のサービス購入"
      );
    }
    return "";
  }

  // クーポンモーダルを表示するか判定
  // 入力画面かつクーポン情報の残数があれば表示できる
  get canUseCoupon() {
    if (this.parent === SystemConst.TICKET_BUY_ORDER) {
      return this.couponCount ? true : false;
    }
    return false;
  }

  async fav() {
    if (this.$store.getters.isLogin) {
      if (this.isDisabled) return;
      this.isDisabled = true;
      await TicketFavoriteService.createTicket({
        ticket_id: this.pTicket.id,
      }).then((rsp: any) => (this.faved = true));
      this.isDisabled = false;
    } else {
      this.refs.toLoginModal.open();
    }
  }

  async unFav() {
    if (this.$store.getters.isLogin) {
      if (this.isDisabled) return;
      this.isDisabled = true;
      this.faved = false;
      await TicketFavoriteService.deleteTicket(this.pTicket.id).then(
        (rsp: any) => (this.faved = false)
      );
      this.isDisabled = false;
    } else {
      this.refs.toLoginModal.open();
    }
  }

  async favedStatus() {
    if (this.$store.getters.isLogin) {
      const {
        data: { ticket_favorite },
      } = await TicketFavoriteService.getTicket(this.pTicket.id);
      this.faved = !!ticket_favorite;
    }
  }

  // createdだと空の値の時に動き出してしまうのでwatchで中身が入るのを待つ
  @Watch("pTicket", { deep: true })
  async onPTicketChanged() {
    if (this.pTicket.ticketId != "" && !this.secretSale) {
      this.favedStatus();
    }
    // 表示購入価格
    this.purchasePrice = Math.floor(
      this.pTicket.price * SystemConst.CONSUMPTION_TAX
    );
    // クーポン情報取得（同期）
    await this.getCouponInfo();

    // 入力画面でクーポンを適用していた際の確認画面遷移時は
    // 適用を入力画面から受け取ったidで実施する
    if (this.parent === SystemConst.TICKET_BUY_CHECK && this.parentCouponId) {
      this.applyCoupon(this.parentCouponId);
    }
  }

  // クーポン適用
  applyCoupon(couponId?: string) {
    // 表示クーポン割引
    this.couponDiscount = this.discountPrice;
    // 表示購入価格 ※販売価格（税込）からの減算（表示はfilterで税乗算無し）
    this.purchasePrice =
      Math.floor(this.pTicket.price * SystemConst.CONSUMPTION_TAX) -
      this.discountPrice;
    if (couponId) {
      this.couponId = couponId;
    } else {
      this.couponId = this.tempCouponId;
    }
  }

  // クーポンモーダルOpen
  openGetCouponModal() {
    this.refs.toGetCouponModal.open();
  }

  // クーポンモーダルからOK押下時の処理
  getCoupon() {
    this.applyCoupon();
  }

  // クーポン情報取得
  async getCouponInfo() {
    try {
      const result = this.parentCouponId
        ? await CouponService.getCoupon(this.parentCouponId)
        : await CouponService.getCoupon();
      // 販売価格がチケット利用下限金額未満の場合、クーポン情報は設定しない
      if (
        !this.pTicket.price ||
        this.pTicket.price < Number(result.data.coupon[0].object)
      ) {
        return;
      }
      this.discountPrice = result.data.coupon[0].amount_off;
      this.couponCount =
        result.data.coupon[0].max_redemptions - result.data.coupon[0].times_redeemed;
      this.tempCouponId = result.data.coupon[0].coupon_id;
      this.couponUsageStartDate = result.data.coupon[0].start_term;
      this.couponUsageEndDate = result.data.coupon[0].end_term;
      this.couponAvailableMinnimumAmount = result.data.coupon[0].object;
    } catch (ex) {
      console.log(ex);
    }
  }

  mounted() {
    // 確認画面ではクーポンIDからクーポン情報を再取得
    if (this.parent === SystemConst.TICKET_BUY_CHECK && this.parentCouponId) {
      this.getCouponInfo();
      this.applyCoupon(this.parentCouponId);
    }
  }
}
